import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';

@Injectable({ providedIn: 'root' })
export class SentryService {
  captureException(error: unknown, context?: Record<string, unknown>): void {
    Sentry.captureException(error, context);
  }

  captureMessage(message: string, context?: { level?: Sentry.SeverityLevel; extra?: Record<string, unknown> }): void {
    Sentry.captureMessage(message, context);
  }

  addBreadcrumb(breadcrumb: { category: string; message: string; level?: Sentry.SeverityLevel; data?: unknown }): void {
    Sentry.addBreadcrumb(breadcrumb);
  }

  setContext(key: string, context: Record<string, unknown>): void {
    Sentry.setContext(key, context);
  }
}
